import LoadingBlock from './loadingBlock';

export default function LoadingSkeletonItem() {
  return (
    <div className='mx-auto mt-4 w-full h-md-down:max-w-[70rem]'>
      <LoadingBlock width='20em' height='1.4em' />
      <div className='mt-4 grid grid-cols-1 gap-10 md:grid-cols-12'>
        <div className='md:col-span-8'>
          <LoadingBlock height='86%' />
          <div className='m-8'></div>
          <LoadingBlock height='2em' />
          <div className='flex flex-col gap-y-6 md:flex-grow'>
            <LoadingBlock height='1.4em' />
            <LoadingBlock height='1.4em' />
            <LoadingBlock height='1.4em' />
            <LoadingBlock height='1.4em' />
            <LoadingBlock height='1.4em' />
          </div>
        </div>
        <div className='md:col-span-4'>
          <LoadingBlock height='300px' />
        </div>
      </div>
    </div>
  );
}
